import React, { forwardRef } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

export const ListItem = forwardRef(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={classnames("list-item-wrapper tw-w-full tw-flex tw-items-center tw-h-10", className)}
      {...props}
    >
      {children}
    </div>
  );
});

ListItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

ListItem.displayName = "ListItem";
